<template>
  <div>
    <b-sidebar
      id="add-kas-sidebar"
      sidebar-class="sidebar-lg"
      bg-variant="white"
      :visible="addKeuanganSidebar"
      right
      no-header
      backdrop
      @hidden="(val) => changeValue(val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5
            class="mb-0"
          >
            {{ kasLocal.id > 0 ? 'Edit Keuangan' : 'Add Keuangan' }}
          </h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
        </div>

        <!-- Body -->
        <validation-observer
          ref="simpleRules"
          class="px-2"
        >
          <b-form>
            <b-row class="px-2">
              <b-col md="12">
                <b-form-group
                  label="Supir"
                  label-for="supir-kas"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Supir"
                    rules="required"
                  >
                    <b-form-select
                      id="supir-kas"
                      v-model="kasLocal.supir"
                      :options="optionsSupir"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Status Supir"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Bis"
                  label-for="bis-kas"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="bis"
                    rules="required"
                  >
                    <b-form-select
                      id="bis-kas"
                      v-model="kasLocal.bis"
                      :options="optionsBis"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Status Supir"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Keterangan"
                  label-for="katerangan-kas"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="katerangan"
                    rules="required"
                  >
                    <b-form-input
                      id="katerangan-kas"
                      v-model="kasLocal.keterangan"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Keterangan"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Jumlah"
                  label-for="jumlah-kas"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Jumlah"
                    rules="required"
                  >
                    <b-form-input
                      id="jumlah-kas"
                      v-model="kasLocal.jumlah"
                      type="number"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Jumlah"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-button
                  variant="primary"
                  class="mr-1"
                  @click="submit()"
                >
                  Submit
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="changeValue(false)"
                >
                  Cancel
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BButton, BCol,
  BRow, BSidebar, BFormSelect,
} from 'bootstrap-vue'
import { required, email } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BButton,
    BCol,
    BRow,
    BSidebar,
    BFormSelect,
  },
  model: {
    prop: 'addKeuanganSidebar',
  },
  props: {
    addKeuanganSidebar: {
      type: Boolean,
      required: true,
    },
    kas: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      email,
      kasLocal: {
        id: null,
        keterangan: null,
        jumlah: null,
        bis: null,
        supir: null,
      },
      optionsSupir: [],
      optionsBis: [],
    }
  },
  watch: {
    kas() {
      this.resetTaskLocal()
    },
  },
  mounted() {
    this.getDataSupir()
    this.getDataBis()
  },
  methods: {
    getDataSupir() {
      this.$http.get('/supir-data').then(response => {
        // eslint-disable-next-line array-callback-return
        response.data.data.map(data => {
          const dataSupir = {
            value: data.id,
            text: data.nama,
          }
          this.optionsSupir.push(dataSupir)
        })
      })
    },
    getDataBis() {
      this.$http.get('/bis').then(response => {
        // eslint-disable-next-line array-callback-return
        response.data.data.map(data => {
          const dataBis = {
            value: data.id,
            text: data.nama,
          }
          this.optionsBis.push(dataBis)
        })
      })
    },
    resetTaskLocal() {
      this.kasLocal = {
        supir: this.kas.supir,
        bis: this.kas.bis,
        jumlah: this.kas.jumlah,
        keterangan: this.kas.keterangan,
      }
    },
    changeValue() {
      const data = {
        id: null,
        bis: null,
        supir: null,
        keterangan: null,
        jumlah: null,
      }
      this.$emit('kas-sidebar-change', data, false)
    },
    submit() {
      if (this.kasLocal.id > 0) {
        this.$emit('submit-data-kas', this.kasLocal)
      } else {
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
            this.$emit('submit-data-kas', this.kasLocal)
          }
        })
      }
    },
  },
}
</script>
<style>
.b-sidebar-body {
  overflow: hidden !important;
}
</style>
